import { Directive } from '@angular/core';

import { LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';
import { entityMultiSelectText } from 'src/app/common-components/multi-select/entity-multi-select-text-content';
import { PhoneNumberOption } from '../models/phone-number-option';

@Directive({
    selector: 'lcs-multi-select-trigger[ndtPhoneNumberMultiSelect]',
    standalone: false
})
export class PhoneNumberMultiSelectTriggerDirective {
   constructor(trigger: LcsMultiSelectTriggerComponent<PhoneNumberOption>) {
      trigger.getTextContent = entityMultiSelectText(trigger, 'phone number');
   }
}
